import { render, staticRenderFns } from "./admin_zbly.vue?vue&type=template&id=1a4b3f33&scoped=true"
import script from "./admin_zbly.vue?vue&type=script&lang=js"
export * from "./admin_zbly.vue?vue&type=script&lang=js"
import style0 from "./admin_zbly.vue?vue&type=style&index=0&id=1a4b3f33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b3f33",
  null
  
)

export default component.exports